<template>
    <div class="fs_dropzone relative min-h-[28px]" @dblclick="preview">
        <input ref="focusCatcher" class="opacity-0 absolute"
               name="notASearchField"
               placeholder="NotASearchField"
               autocomplete="off"
               style="width: 1px; height:1px; margin:0px; padding:0px; overflow: hidden"
               @keydown.enter="(e) => {editable = true; editName(false)}"
               @keydown.space="(e) => {preview()}"
               @keydown.up="(e) => {$emit('previousNode',e)}"
               @keydown.down="(e) => {$emit('nextNode',e)}"
               @keydown.left="(e) => {$emit('previousNode',e)}"
               @keydown.right="(e) => {$emit('nextNode',e)}"
        >
        <vue2-dropzone ref="myDropzone"
                       :options="dropzoneOptions"
                       :id="'dz'+(data?data.id:'')"
                       :duplicateCheck="false"
                       :includeStyling="false"
                       :useCustomSlot="true"
                       v-on:vdropzone-success="success"
                       class=""
                       :class="innerClass"
        >
            <div
                class="flex m-0 select-none items-center border-border-dashed border-transparent cursor-pointer relative">
                <div class="relative shrink-0" :class="prefs.size==='large'?'w-14 h-14':'w-8 h-8'" :key="thumbnailKey">
                    <img v-for="(revision,index) in file.revisions.slice(0,4)"
                         :src="revision.thumbnail"
                         alt="" loading="lazy"
                         class="absolute ml-0.5 mt-1 rounded object-cover pointer-events-none border border-gray-300 bg-white"
                         :class="prefs.size==='large'?'h-12 w-12':'h-6 w-6'"
                         :style="'transform:rotate('+seededRandom(index - revision.createdAt.unix(),-35,35)+'deg);'">
                    <img
                        :src="getThumbnailUrl()"
                        alt="" loading="lazy"
                        class="absolute ml-0.5 mt-1 rounded object-cover pointer-events-none border border-gray-300 bg-white"
                        :class="prefs.size==='large'?'h-12 w-12':'h-6 w-6'">
                </div>
                <div class="ml-2 min-w-0 flex-1"
                     :class="prefs.size==='small'?'pt-1 flex align-items-center pr-1':''">
                    <div class="flex-1 overflow-hidden">
                        <autoresizable-input v-if="editingName" :limit-max-to-parent="true">
                            <page-cell name="notASearchField" v-model="newName" @keydown="keyDown" @blur="updateName"
                                       ref="item-name"
                                       placeholder="File..."
                                       class="inline-block overflow-hidden border-none shadow-none ring-0 outline-none bg-transparent text-sm p-0 mt-0 mx-0"
                                       :class="prefs.size==='small'?' mb-1 mt-0.5 ml-0.5':' mb-0'">
                            </page-cell>
                        </autoresizable-input>
                        <div @mouseup="mousedUp" @dblclick="preview" @click="editName" v-else
                             v-text="file.name"
                             class="inline-block max-w-full overflow-x-hidden overflow-y-hidden text-ellipsis whitespace-nowrap text-sm p-0 mt-0.5 mx-0"
                             :class="(prefs.size==='small'?'ml-0.5 mb-1 ':' mb-0 ') + (this.selected.includes(this.file)?'cursor-text':'')"
                        >
                        </div>
                    </div>
                    <template v-if="prefs.size==='large'">
                        <span
                            class="block overflow-hidden whitespace-nowrap text-xs text-gray-500 p-0 flex-none"
                        >{{ bytesToHuman(file.size) + ' : ' + file.createdAt.format('MMMM Do YYYY, h:mm:ss a') }}</span>
                        <span
                            class="block overflow-hidden whitespace-nowrap text-xs text-gray-500 p-0 flex-none">
                        <div class="inline-block" v-for="(tag, index) in file.tags">
                            <div class="w-2.5 h-2.5 inline-block rounded-full flex-0 mt-1"
                                 :style="'border: 0.8px solid rgba(150, 150, 150, .3);  background-color: '+(getFsTag(tag)?getFsTag(tag).colorHex:'#FFF')"></div>
                            <div class="inline-block mr-1">{{ tag }}</div>
                        </div>
                            </span>
                    </template>
                    <template v-else>
                        <div class="flex-0">
                            <div v-for="(tag, index) in file.tags"
                                 class="w-2.5 h-2.5 inline-block rounded-full flex-0 mt-1.5 mr-0.5"
                                 :style="'border: 0.8px solid rgba(150, 150, 150, .3);  background-color: '+(getFsTag(tag)?getFsTag(tag).colorHex:'#FFF')"></div>
                        </div>
                        <span
                            class="overflow-visible whitespace-nowrap text-xs text-gray-500 p-0 flex-0 ml-1 w-[4.5rem] text-right pr-0 mt-1"
                        >{{ bytesToHuman(file.size) }}</span>
                        <span
                            class="overflow-visible whitespace-nowrap text-xs text-gray-500 p-0 flex-0 ml-1 w-[5.5rem] text-right pr-0 mt-1"
                        >{{ file.createdAt.format('DD/MM/YY HH:mm') }}</span>
                    </template>
                </div>
            </div>
            <div style="width: 1px; height:1px; overflow: hidden" class="opacity-0 absolute" v-if="data"
                 :id="'manual-trigger-'+this.data.id"></div>
            <div class="block w-full m-0 pr-3 overflow-hidden max-h-20 text-right"
                 v-if="filesToBeConfirmed.length || filesBeingProcessed.length || filesToBeProcessed.length">
                {{ this.filesToBeProcessed.length + this.filesBeingProcessed.length }} remaining files to upload
                ({{ this.filesToBeConfirmed.length }} awaiting confirmation)
            </div>
            <div class="block w-full m-0 pr-3 overflow-hidden max-h-20 text-right text-red-600"
                 v-if="filesErrored.length">
                {{ this.filesErrored.length }} files failed to upload - contact support
            </div>
            <div :id="'node-preview-'+this.data.id" class="block w-full m-0" v-if="data"></div>
        </vue2-dropzone>
    </div>
</template>

<script>
import AutoresizableInput from "../ui/AutoresizableInput";
import PageCell from "../ui/PageCell.vue";
import vue2Dropzone from "vue2-dropzone";
import {uuid} from "../../utils";
import {Fs} from '@models'
import {cloneDeep} from "lodash";

export default {
    components: {vue2Dropzone, PageCell, AutoresizableInput},
    props: {
        filesystem: Object,
        file: Object,
        rotations: Object,
        data: Object,
        selected: Array,
        current: Array,
        prefs: Object,
        innerClass: String,
        lastUp: false,
        lastDown: false,
        canUpload: true,
    },
    data() {
        return {
            dropzoneOptions: {
                url: 'https://a',
                autoProcessQueue: false,
                autoQueue: false,
                parallelUploads: 25,
                maxFilesize: 5120,
                useFsAccessApi: false,
                clickable: this.data ? ('#manual-trigger-' + this.data.id) : null,
                previewsContainer: this.data ? ('#node-preview-' + this.data.id) : null,
            },
            newName: this.file.name,
            editingName: false,
            editable: false,
            singleClickTimeout: false,
            lastAddedCount: -1,
            lastConfirmedCount: -1,
            filesToBeProcessed: [],
            filesBeingProcessed: [],
            filesToBeConfirmed: [],
            filesErrored: [],
            thumbnailKey: 0,
        }
    },
    watch: {
        'rotations.key': {
            handler(a, b) {
                this.$forceUpdate()
            },
        },
    },
    computed: {},
    methods: {
        getFsTag(tag) {
            return this.filesystem.tags.find((t) => t.name === tag)
        },
        seededRandom(seed, min, max) {
            function mulberry32(a) {
                var t = a += 0x6D2B79F5;
                t = Math.imul(t ^ t >>> 15, t | 1);
                t ^= t + Math.imul(t ^ t >>> 7, t | 61);
                return ((t ^ t >>> 14) >>> 0) / 4294967296;
            }

            let option = Math.floor(min + (mulberry32(seed) * (Math.abs(max - min))))
            return option
        },
        mousedUp(e) {
            this.editable = !e.ctrlKey && !e.shiftKey && !e.metaKey && (this.lastDown === this.lastUp)
        },
        editName(e) {
            if (!this.editable) return;
            if (this.selected.includes(this.file)) {
                if (e) {
                    e.preventDefault()
                    e.stopPropagation()
                }
                this.singleClickTimeout = setTimeout(() => {
                    this.newName = this.file.name
                    this.editingName = true
                    this.$nextTick(() => {
                        if (this.$refs["item-name"]) {
                            this.$refs["item-name"].$el.focus();
                        }
                    })
                }, 250)
            }
        },
        keyDown(e) {
            if (e.key === 'Escape') {
                this.newName = this.file.name
                e.target.blur();
            }
        },
        updateName(e) {
            this.editingName = false
            if (this.newName !== this.file.name) {
                this.$emit('renameNode', this.file, this.newName)
            }
            this.$refs['focusCatcher'].focus();
        },
        bytesToHuman(bytes) {
            if (bytes < 1000) {
                return bytes + ' B'
            } else if (bytes < 1000 * 1000) {
                return Math.round((bytes / 1000) * 100) / 100 + ' kB'
            } else if (bytes < 1000 * 1000 * 1000) {
                return Math.round((bytes / (1000 * 1000)) * 100) / 100 + ' MB'
            } else {
                return Math.round((bytes / (1000 * 1000 * 1000)) * 100) / 100 + ' GB'
            }
        },
        selectDown(e) {
            this.$emit('selectDown', this.data, e)
        },
        selectUp(e) {
            this.$emit('selectUp', this.data, e)
        },
        preview(e, node) {
            this.$modals.open('fs-preview-modal', {
                filesystem: this.filesystem,
                previewObject: node ? node : this.file,
                current: this.current,
                rotations: this.rotations,
                tags: false,
                closed: () => {
                    this.$emit('previewClosed')
                    this.$nextTick(() => {
                        this.$refs.focusCatcher.focus()
                    })
                },
                selected: (file) => {
                    this.$emit('newSelection', file,file.nodeGroup)
                },
            })
        },
        async triggerNewFiles(files) {
            this.intentUpdateInProgress = true;
            files.forEach((i) => {
                i.id = uuid()
            })
            this.filesBeingProcessed.push(...files);
            await this.filesystem.createUploadIntent(files.map(i => {
                return {
                    id: i.id,
                    size: i.size,
                    name: i.name,
                    relativePath: i.fullPath ? i.fullPath.slice(0, 0 - i.name.length) : '/',
                    mimeType: i.type ? i.type : 'application/octet-stream'
                }
            }), this.file.id).then((value) => {
                if (!value) {
                    console.log('Upload-Intent creation failed!')
                    files.forEach((i, key) => {
                        this.$refs.myDropzone.$el.dropzone.removeFile(i);
                        this.filesBeingProcessed.splice(this.filesToBeProcessed.indexOf(i), 1);
                        this.filesErrored.push(1);
                    })
                    return;
                }
                files.forEach((i, key) => {
                    i.uploadTarget = value.files.find((i2) => i2.id === i.id);
                    i.uploadConfirmation = {
                        'uploadIntentId': value.id,
                        'uploadFileId': i.uploadTarget.id,
                    }
                    i.previewElement.classList.remove('hidden')
                })
                files.forEach((i, key) => {
                    this.$refs.myDropzone.$el.dropzone.enqueueFile(i);
                })
                this.intentUpdateInProgress = false;
                this.$refs.myDropzone.processQueue();
            })
        },
        filesAdded() {
            this.$emit('uploadingStarted', this.file.id)
            if (this.addedTimer) {
                clearTimeout(this.addedTimer)
            }
            if (!this.intentUpdateInProgress) {
                if (this.filesToBeProcessed.length === 0) {
                    this.lastAddedCount = -1;
                    return;
//                } else if (this.filesToBeProcessed.length > 100) {
//                    this.triggerNewFiles(this.filesToBeProcessed.splice(0, 100))
                } else if (this.filesToBeProcessed.length === this.lastAddedCount) {
                    this.triggerNewFiles(this.filesToBeProcessed.splice(0, this.filesToBeProcessed.length))
                }
            }
            this.lastAddedCount = this.filesToBeProcessed.length;
            this.addedTimer = setTimeout(() => {
                this.filesAdded()
            }, 200);
        },
        async triggerConfirmation(files) {
            this.intentUpdateInProgress = true;
            await this.filesystem.confirmUploads(files.map(i => i.uploadConfirmation))
                .catch((e) => {
                    alert(e.message)
                })
                .then(async (result) => {
                    this.intentUpdateInProgress = false;
                    files.forEach((i, key) => {
                        setTimeout(() => {
                            this.$refs.myDropzone ? this.$refs.myDropzone.$el.dropzone.removeFile(i) : null
                        }, 120);
                    })
                    if (this.filesToBeConfirmed.length + this.filesToBeProcessed.length + this.filesBeingProcessed.length === 0) {
                        let newFs = await Fs.find(this.filesystem.id)
                        this.filesystem.nodes.splice(0, this.filesystem.nodes.length, ...newFs.nodes)
                        Object.assign(this.file, newFs.getNodeById(this.file.id))
                        this.$emit('uploadingFinished')
                        this.$emit('reload')
                    }
                })
        },
        success(file) {
            this.filesBeingProcessed.splice(this.filesBeingProcessed.indexOf(file), 1);
            this.filesToBeConfirmed.push(file)
            this.filesconfirmed()
            file.previewElement.classList.add('dz-shrink')
        },
        filesconfirmed() {
            if (this.successTimer) {
                clearTimeout(this.successTimer)
            }
            if (!this.intentUpdateInProgress) {
                if (this.filesToBeConfirmed.length === 0) {
                    this.lastConfirmedCount = -1;
                    return;
                } else if (this.filesToBeConfirmed.length > 200) {
                    this.triggerConfirmation(this.filesToBeConfirmed.splice(0, 200))
                } else if (this.filesToBeConfirmed.length === this.lastConfirmedCount) {
                    this.triggerConfirmation(this.filesToBeConfirmed.splice(0, this.filesToBeConfirmed.length))
                }
            }
            this.lastConfirmedCount = this.filesToBeConfirmed.length;
            this.successTimer = setTimeout(() => {
                this.filesconfirmed()
            }, 150);
        },
        uploadRevision() {
            this.$refs.myDropzone.$el.dropzone.clickableElements[0].click();
        },
        getThumbnailUrl() {
            if (!this.file.supportsRotations) {
                return this.file.thumbnail+'&k='+this.thumbnailKey;
            }
            let rot = this.rotations[this.file.id];
            if (!rot) {
                return this.file.thumbnail+'&k='+this.thumbnailKey;
            }
            return (this.file.rotations[rot]?this.file.rotations[rot].thumbnail:this.file.thumbnail)+'&k='+this.thumbnailKey;
        },
    },
    mounted() {
        let that = this;
        eventBus.$on('thumbnail-generated-' + this.filesystem.id + '|' + this.file.id, (e) => {
            Fs.incrementThumbnailKey(this.filesystem.id,this.file.id);
            this.thumbnailKey = Fs.getThumbnailKey(this.filesystem.id,this.file.id);
        });
        this.thumbnailKey = Fs.getThumbnailKey(this.filesystem.id,this.file.id);
        if (this.data) {
            this.$refs.myDropzone.$el.dropzone.on('addedfile', function (file) {
                if (that.canUpload !== true && (that.canUpload !== that.file.id)) {
                    this.removeFile(file)
                    return;
                }
                file.previewElement.classList.add('hidden')
                that.$modals.confirm({
                    title: 'This will add the file '+file.name+' as a new Revision of the existing file',
                    button: 'Yes, add as new revision',
                    handle: async () => {
                        file.previewElement.classList.add('hidden')
                        that.filesToBeProcessed.push(file)
                        that.filesAdded(this)
                    },
                    afterClose: () => {
                        this.removeFile(file)
                    }
                })
            });
            this.$refs.myDropzone.$el.dropzone.on('sending', function (file, xhr, formData) {
                xhr.open('POST', file.uploadTarget.url);
                Object.entries(file.uploadTarget.inputs).forEach(entry => {
                    const [key, value] = entry;
                    formData.append(key, value);
                });
            });
        }
    }
}
</script>